module.exports = __webpack_public_path__ + "img/潘先生_35-04.4a62446a.jpg";